var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pg-cnt-bx"},[(_vm.isMobileCheck == 'false' || _vm.isTabletCheck == 'false' && _vm.currentRouteName !='dsmarketHomePage')?_c('dsNav'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mrkt-rtr-1"},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ec7109e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dsmarket/dsmarketHome.vue
// module id = null
// module chunks = 